<template>
    <div class="container has-no-scroll">
        <div class="columns">
            <div class="column" v-bind:class="{ 'is-hidden-touch' : activeScreen !== 1 }">
                <div class="columns">
                    <div class="column">
                        <div class="guides-list">
                            <a class="guides-list__back-btn" href="/my-plan">Return to my plan</a>
                            <div class="guides-list__title">{{ guideCategory.title }}</div>
                            <a class="guides-list__item"
                               v-bind:class="{ 'is-active' : currentGuide && item.id == currentGuide.id }"
                               v-for="item in guides"
                               v-on:click="setCurrentGuide(item)"
                            >
                                {{ item.title }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column" v-bind:class="{ 'is-hidden-touch' : activeScreen !== 2 }">
                <div class="guide" v-if="guide">
                    <div class="guide__video" v-if="guide.settings.video_id">
                        <iframe v-bind:src="'https://player.vimeo.com/video/' + guide.settings.video_id + '?autoplay=1&loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media'" allowfullscreen allowtransparency></iframe>
                    </div>
                    <div class="guide__header">
                        <h4 class="guide__header__title">Guide <strong>// {{ guide.title }}</strong></h4>
                        <a
                            class="guide__header__button"
                            v-if="guide.settings.actionlist_cta_text"
                            v-on:click="showActionList"
                        >
                            {{ guide.settings.actionlist_cta_text }}
                        </a>
                    </div>
                    <div class="guide__list">
                        <div class="guide__list__item"
                             v-bind:class="{ 'is-expanded' : openGuideItems.indexOf(key) !== -1 }"
                             v-for="(guideItem, key) in guide.guide"
                             v-if="guide.guide && guide.guide.length > 0"
                        >
                            <h4 class="guide__list__item__title">{{ guideItem.box_title }}</h4>
                            <div class="guide__list__item__content"
                                 v-html="guideItem.box_content_filtered"
                            ></div>
                            <a class="guide__list__item__show-more"
                               v-bind:class="{ 'is-active' : openGuideItems.indexOf(key) == -1 }"
                               v-on:click="openGuideItem(key)"
                            >
                                Read more
                            </a>
                            <a class="guide__list__item__show-less"
                               v-bind:class="{ 'is-active' : openGuideItems.indexOf(key) !== -1 }"
                               v-on:click="closeGuideItem(key)"
                            >
                                Read less
                            </a>
                            <a class="guide__list__item__audionote" target="_blank"
                               v-bind:href="guideItem.audionote_url"
                               v-if="guideItem.audionote_url"
                            >
                                Listen as audionote
                            </a>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
            <div class="column" v-bind:class="{ 'is-hidden-touch' : activeScreen !== 3 }">
                <div class="guide-action-list"
                     v-bind:class="{ 'has-heading' : guide.actionlist_settings.has_headings }"
                     v-if="guide && guide.settings.actionlist_cta_text"
                >
                    <h3 class="guide-action-list__header">Action list</h3>
                    <h4 class="guide-action-list__title">{{ guide.actionlist_settings.title }}</h4>
                    <div
                        v-for="(step, key) in guide.actionlist_steps"
                        v-if="guide.actionlist_steps && guide.actionlist_steps.length > 0"
                    >
                        <div class="guide-action-list__item"
                             v-bind:class="{ 'is-black' : guide.actionlist_settings.has_headings }"
                             v-if="step.help_text"
                        >
                            <div class="guide-action-list__item__container">
                                <span class="guide-action-list__item__title">{{ step.action }}</span>
                                <a class="guide-action-list__item__help-btn" v-on:click="toggleHelpText(key)">How</a>
                            </div>
                            <div class="guide-action-list__item__help-text"
                                 v-bind:class="{ 'is-active' : openHelpTexts.indexOf(key) !== -1 }"
                            >
                                <a class="guide-action-list__item__help-text__close"
                                   v-on:click="closeHelpText(key)"
                                >Close</a>
                                <div v-html="step.help_text_filtered"></div>
                            </div>
                        </div>
                        <div class="guide-action-list__item" v-else>
                            <div class="guide-action-list__item__container">
                                <span class="guide-action-list__item__title">{{ step.action }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="guide-action-list__item has-margin-t30">
                        <div class="guide-action-list__item__container">
                            <a class="guide-action-list__item__help-btn is-green"
                               v-on:click="toggleHelpText('cta')"
                            >
                                {{ guide.actionlist_settings.cta_text }}
                            </a>
                        </div>
                        <div class="guide-action-list__item__help-text"
                             v-bind:class="{ 'is-active' : openHelpTexts.indexOf('cta') !== -1 }"
                        >
                            <a class="guide-action-list__item__help-text__close"
                               v-on:click="closeHelpText('cta')"
                            >Close</a>
                            <div v-html="guide.actionlist_settings.cta_help_text_filtered"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';

    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            if (this.defaultGuide) {
                this.guide = this.defaultGuide;
            }

            window.history.pushState({
                name: 'guide.list'
            }, null, '/guides/' + this.guideCategory.slug);

            if (this.guide) {
                this.showGuide(this.guide);
            }

            if (this.isActionList) {
                this.showActionList();
            }

            window.addEventListener('popstate', function(e) {
                const state = e.state;

                if (state.name === 'guide.list') {
                    this.lastGuide = this.guide;
                    this.guide = null;
                    this.openGuideItems = [];

                    this.activeScreen = 1;
                }

                if (state.name === 'guide.show') {
                    this.guide = this.lastGuide;

                    this.showGuide(this.guide, false);
                }

                if (state.name === 'guide.actionlist') {
                    this.showActionList();
                }
            }.bind(this));
        },
        data: function () {
            return {
                activeScreen: 1,
                currentGuide: null,
                guide: null,
                lastGuide: null,
                openGuideItems: [],
                openHelpTexts: []
            }
        },
        methods: {
            closeGuideItem: function (key) {
                this.openGuideItems = this.openGuideItems.filter(function (value) {
                    return value != key;
                });
            },
            closeHelpText: function (key) {
                this.openHelpTexts = this.openHelpTexts.filter(function (value) {
                    return value != key;
                });
            },
            getGuide: function (id) {
                eventBus.$emit('show-loader');

                this.guide = null;
                this.openGuideItems = [];

                this.$http.get('/api/guides/' + id).then(function(response) {
                    eventBus.$emit('hide-loader');

                    this.guide = response.body;
                }.bind(this), function () {
                    console.error('ERROR: there was an error fetching data.');

                    eventBus.$emit('hide-loader');
                });
            },
            handleBackwardControlClick: function () {
                window.history.go(-1);
            },
            handleForwardControlClick: function () {
                if (this.activeScreen === 1) {
                    window.history.go(1);
                } else {
                    this.showActionList();
                }
            },
            openGuideItem: function (key) {
                this.pushGtmGuideOpen(key);
                this.openGuideItems.push(key);
            },
            pushGtmActionListOpen: function (key) {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'actionListHow',
                    'actionListItem': key !== 'cta'
                        ? this.guide.actionlist_steps[key].action.toLowerCase()
                        : this.guide.actionlist_settings.cta_text.toLowerCase()
                });
            },
            pushGtmGuideItem: function (subject) {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'guideSubject',
                    'guideSubject': subject.toLowerCase()
                });
            },
            pushGtmGuideOpen: function (key) {
                if (!window.dataLayer) {
                    return;
                }

                window.dataLayer.push({
                    'event': 'guideSubjectRead',
                    'guideSubjectRead': this.guide.guide[key].box_title.toLowerCase()
                });
            },
            setCurrentGuide: function (guide) {
                this.currentGuide = _.cloneDeep(guide);

                this.showGuide(guide);
                this.pushGtmGuideItem(guide.title);
                this.getGuide(this.currentGuide.id);
            },
            showActionList: function () {
                this.activeScreen = 3;

                this.lastGuide = this.guide;

                window.history.pushState({
                    name: 'guide.actionlist',
                }, null, '/guides/' + this.guideCategory.slug + '/' + this.guide.slug + '/actionlist');
            },
            showGuide: function (guide, setState = true) {
                this.activeScreen = 2;

                if (setState) {
                    window.history.pushState({
                        name: 'guide.show',
                        guide: guide
                    }, null, '/guides/' + this.guideCategory.slug + '/' + guide.slug);
                }
            },
            toggleHelpText: function (key) {
                if (this.openHelpTexts.indexOf(key) == -1) {
                    this.pushGtmActionListOpen(key);

                    this.openHelpTexts.push(key);
                } else {
                    this.openHelpTexts = this.openHelpTexts.filter(function (value) {
                        return value != key;
                    });
                }
            }
        },
        props: {
            defaultGuide: {
                required: true
            },
            guideCategory: {
                required: true,
                type: Object
            },
            guides: {
                required: true,
                type: Array
            },
            isActionList: {
                required: true,
                type: Boolean
            }
        }
    }
</script>
